import { render } from "./NavBarHeader.vue?vue&type=template&id=4c5e2fb3&scoped=true"
import script from "./NavBarHeader.vue?vue&type=script&lang=js"
export * from "./NavBarHeader.vue?vue&type=script&lang=js"

import "./NavBarHeader.vue?vue&type=style&index=0&id=4c5e2fb3&scoped=true&lang=css"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5e2fb3"]])

export default __exports__